var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-wrpper"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.externalSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }